<app-header>
  <h1 app-overline>Step 2</h1>
  <h2 app-title>Select your Robot Configuration(s)</h2>
</app-header>

<div class="robot-configs-wrapper">
  <ng-container
    *ngIf="filteredRobotConfig$ | async as filteredRobotConfigs; else loading"
  >
    <app-card-robot-config-list
      [robotConfigurations]="filteredRobotConfigs"
      [selectedConfigsOnInit]="selectedRobotConfigsOnInit"
      [sortOptions]="robotConfigSortOptions"
      (textFilter)="textFilterSubject.next($event)"
      (sortSelected)="sortSubject.next($event)"
      (selectedConfig)="selectedConfigsEmitter.emit($event)"
    >
    </app-card-robot-config-list>
  </ng-container>

  <ng-template #loading>
    <app-loading></app-loading>
  </ng-template>
</div>
